import { Link } from 'react-router-dom'
import { UserButton } from '@clerk/clerk-react'

// Stripe redirects here if the user abandons Checkout. No charge was made.
export default function CheckoutCancelPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm">
        <div className="container mx-auto px-4 py-4">
          <nav className="flex items-center justify-between">
            <Link to="/" className="text-2xl font-bold text-indigo-600">
              BankStatementReader
            </Link>
            <div className="flex items-center gap-4">
              <Link to="/dashboard" className="px-4 py-2 text-gray-700">Dashboard</Link>
              <UserButton />
            </div>
          </nav>
        </div>
      </header>

      <main className="container mx-auto px-4 py-16">
        <div className="max-w-md mx-auto bg-white rounded-lg shadow-lg p-8 text-center">
          <div className="text-5xl mb-4">🚫</div>
          <h1 className="text-2xl font-bold text-gray-900">Checkout canceled</h1>
          <p className="text-gray-600 mt-2">No charge was made. You can pick a plan whenever you're ready.</p>
          <div className="flex items-center justify-center gap-3 mt-6">
            <Link to="/#pricing" className="px-6 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700">
              View Plans
            </Link>
            <Link to="/dashboard" className="px-6 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200">
              Dashboard
            </Link>
          </div>
        </div>
      </main>
    </div>
  )
}
